<div class="basic-container" [ngClass]="['border-color-' + typeCode]" [formGroup]="editForm"
  *ngIf="device && deviceTypeData" [@appear]="device.externalDeviceId">
  <mat-list class="device-basic-list">
    <mat-list-item>
      <div matListItemTitle class="basic-item">
        <span class="bold-column">{{'devices.detail.basic.device-id' | translate}}</span>
        <span>{{device.deviceId}}</span>
      </div>
    </mat-list-item>
    <mat-list-item>
      <div matListItemTitle class="basic-item">
        <span class="bold-column">{{'devices.detail.basic.ext-device-type-code' | translate}}</span>
        <span>{{device.externalDeviceTypeCode}}</span>
      </div>
    </mat-list-item>
    <mat-list-item>
      <div matListItemTitle class="basic-item">
        <span class="bold-column">{{'devices.detail.basic.device-type-name' | translate}}</span>
        <span>{{deviceTypeData.deviceTypeName}}</span>
      </div>
    </mat-list-item>
    <mat-list-item class="link-item">
      <div matListItemTitle class="basic-item">
        <span class="bold-column">{{'devices.detail.basic.status' | translate}}</span>
        <span><mat-icon *ngIf="isStatus" color="primary" class="status-icon" [ngClass]="'status-icon-' + device.status"
            (click)="checkoutStatus()">{{
            statusIcon
            }}</mat-icon>{{device.status}}</span>
      </div>
    </mat-list-item>
    <mat-list-item>
      <div matListItemTitle class="basic-item">
        <span class="bold-column">{{'devices.detail.basic.last-updated' | translate}}</span>
        <span>{{device.lastUpdatedTimestamp | defaultDate }}</span>
      </div>
    </mat-list-item>
    <mat-list-item *ngIf="device.createdTimestamp">
      <div matListItemTitle class="basic-item">
        <span class="bold-column">{{'devices.detail.basic.created' | translate}}</span>
        <span>{{device.createdTimestamp | defaultDate }}</span>
      </div>
    </mat-list-item>
    <mat-list-item>
      <div matListItemTitle class="basic-item">
        <span class="bold-column">{{'devices.detail.mode.title' | translate}}</span>
        <span>{{'devices.detail.mode.' + device.writeRight | translate}}</span>
      </div>
    </mat-list-item>
    <mat-list-item  *ngIf="itemData.gateExtDeviceId && deviceType === Keys.GATE">
      <div matListItemTitle class="basic-item">
        <span class="bold-column">{{'devices.detail.basic.days-until-next-service' | translate}}</span>
        <span>{{getRandomNumber() }}</span>
      </div>
    </mat-list-item>
    <mat-list-item *ngIf="itemData.gateExtDeviceId && deviceType === Keys.SZT">
      <div matListItemTitle class="basic-item">
        <span class="bold-column">{{'devices.detail.basic.datasheet' | translate}}</span>
        <span class="link"
        (click)="!isDownloading && downloadDatasheet($event)"
        [class.disabled]="isDownloading">{{'devices.table.header.download' | translate}}</span>
        </div>
    </mat-list-item>
  </mat-list>
  <mat-list class="device-basic-list form-list" *ngIf="showLogistic">
    <mat-list-item *ngIf="device.logisticStatus">
      <div matListItemTitle class="basic-item">
        <span class="bold-column">{{'devices.detail.basic.logistic-status' | translate}}</span>
        <span>{{device.logisticStatus}}</span>
      </div>
    </mat-list-item>
    <mat-list-item *ngIf="device.logisticStatusDesc">
      <div matListItemTitle class="basic-item">
        <span class="bold-column">{{'devices.detail.basic.logistic-status-desc' | translate}}</span>
        <span>{{device.logisticStatusDesc}}</span>
      </div>
    </mat-list-item>
    <button mat-stroked-button color="transparent" class="logistic-edit-button" *ngIf="canEdit"
      (click)="toggleModify()">
      <mat-icon>edit</mat-icon>{{ 'devices.detail.basic.logistic-status-edit' |
      translate}}
    </button>
  </mat-list>
  <mat-list class="device-basic-list form-list" *ngIf="modify">
    <mat-list-item class="form-list-item">
      <div matListItemTitle class="basic-item">
        <mat-form-field appearance="outline" class="edit-form-field">
          <mat-label>{{'devices.detail.basic.logistic-status' | translate}}</mat-label>
          <input type="text" matInput formControlName="logisticStatus" [matAutocomplete]="logAuto" maxlength="20">
          <mat-autocomplete autoActiveFirstOption #logAuto="matAutocomplete">
            <mat-option *ngFor="let logValue of logValuesObservable | async" [value]="logValue">
              {{logValue}}
            </mat-option>
          </mat-autocomplete>
          <button [ngStyle]="{'visibility': emptyFilter('logisticStatus') ? 'hidden' : 'visible'}" matSuffix
            mat-icon-button aria-label="Clear" (click)="clearFilter('logisticStatus', $event)">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </mat-list-item>
    <mat-list-item class="form-list-item">
      <div matListItemTitle class="basic-item">
        <mat-form-field appearance="outline" class="edit-form-field">
          <mat-label>{{'devices.detail.basic.logistic-status-desc' | translate}}</mat-label>
          <textarea matInput formControlName="logisticStatusDesc" cdkTextareaAutosize #logDescArea="cdkTextareaAutosize"
            maxlength="256"></textarea>
          <button [ngStyle]="{'visibility': emptyFilter('logisticStatusDesc') ? 'hidden' : 'visible'}" matSuffix
            mat-icon-button aria-label="Clear" (click)="clearFilter('logisticStatusDesc', $event)">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </mat-list-item>
    <div class="logistic-edit-buttons">
      <button mat-stroked-button color="transparent" class="logistic-edit-button" (click)="toggleModify()">
        <mat-icon>cancel</mat-icon>{{ 'button.cancel' | translate}}
      </button>
      <button mat-stroked-button color="transparent" class="logistic-edit-button" (click)="saveLogistic()">
        <mat-icon>save</mat-icon>{{ 'button.save' | translate}}
      </button>
    </div>
  </mat-list>
  <div class="hideable-container" *ngIf="expanded" [@shrink]="expanded">
    <mat-list class="device-basic-list">
      <mat-list-item *ngIf="device.firmwareId">
        <div matListItemTitle class="basic-item">
          <span class="bold-column">{{'devices.detail.basic.firmware-id' | translate}}</span>
          <span>{{device.firmwareId}}</span>
        </div>
      </mat-list-item>
      <mat-list-item *ngIf="device.firmwareType">
        <div matListItemTitle class="basic-item">
          <span class="bold-column">{{'devices.detail.basic.firmware-type' | translate}}</span>
          <span>{{device.firmwareType}}</span>
        </div>
      </mat-list-item>
      <mat-list-item *ngIf="device.firmwareVersion">
        <div matListItemTitle class="basic-item">
          <span class="bold-column">{{'devices.detail.basic.firmware-version' | translate}}</span>
          <span>{{device.firmwareVersion}}</span>
        </div>
      </mat-list-item>
      <mat-list-item *ngIf="device.lastChangeByMessageId">
        <div matListItemTitle class="basic-item">
          <span class="bold-column">{{'devices.detail.basic.last-message' | translate}}</span>
          <span>{{device.lastChangeByMessageId}}</span>
        </div>
      </mat-list-item>
    </mat-list>
    <mat-list [ngClass]="{ 'empty-list': !linkItems.length }" class="device-basic-list"
      *ngFor="let linkItem of linkItems">
      <mat-list-item *ngIf="linkItem.externalDeviceId !== device.externalDeviceId" class="link-item">
        <div matListItemTitle class="basic-item">
          <span class="bold-column">{{Types[linkItem.externalDeviceTypeCode].translateBasicString + 'id' |
            translate}}</span>
          <span>{{linkItem.externalDeviceId}}<mat-icon color="primary" class="link-icon"
              (click)="selectId(linkItem.externalDeviceTypeCode)">link</mat-icon></span>
        </div>
      </mat-list-item>
      <mat-list-item *ngIf="linkItem.externalDeviceId !== device.externalDeviceId" class="link-item">
        <div matListItemTitle class="basic-item">
          <span class="bold-column">{{Types[linkItem.externalDeviceTypeCode].translateBasicString + 'device-id' |
            translate}}</span>
          <span>{{linkItem.deviceId}}</span>
        </div>
      </mat-list-item>
      <mat-list-item class="link-item">
        <div matListItemTitle class="basic-item">
          <span class="bold-column">{{Types[linkItem.externalDeviceTypeCode].translateBasicString + 'customer-id' |
            translate}}</span>
          <span>{{linkItem.customerId}}</span>
        </div>
      </mat-list-item>
      <mat-list-item class="link-item">
        <div matListItemTitle class="basic-item">
          <span class="bold-column">{{Types[linkItem.externalDeviceTypeCode].translateBasicString + 'customer-name' |
            translate}}</span>
          <span>{{linkItem.customerName}}</span>
        </div>
      </mat-list-item>
    </mat-list>
  </div>
  <button mat-flat-button color="transparent" class="detail-button" (click)="expanded = !expanded">
    <mat-icon *ngIf="!expanded">more_horiz</mat-icon>
    <mat-icon *ngIf="expanded">expand_less</mat-icon>
  </button>
</div>
<div class="loading-overlay" *ngIf="loading">
  <mat-progress-spinner mode="indeterminate" diameter="50">
  </mat-progress-spinner>
</div>